@if (car) {
  <div class="car-detail__info-boxes {{ classes }}">
    @if (car.factoryWarrantyDate || car.factoryWarrantyKm) {
      <app-box-section [title]="'carDetail.specification.warranty' | translate" [icon]="'warranty'" [align-items]="'center'">
        {{ 'carDetail.specification.factoryWarrantyTo' | translate: { make: car.make.title } }}
        <span class="car-detail__info-boxes-value">
          @if (car.factoryWarrantyDate) {
            {{ car.factoryWarrantyDate | date: 'd.M.yyyy' }}
          }
          @if (car.factoryWarrantyDate && car.factoryWarrantyKm) {
            {{ 'globals.or' | translate }}
          }
          @if (car.factoryWarrantyKm) {
            {{ car.factoryWarrantyKm | thousands }}&nbsp;km
          }
        </span>
      </app-box-section>
    }
    @if (car.model.lastServiceBookDate !== null && car.model.lastServiceBookKm !== null) {
      <app-box-section [title]="'carDetail.specification.carService' | translate" [icon]="'service'" [align-items]="'center'">
        {{ 'carDetail.specification.lastService' | translate }}
        @if (car.model.lastServiceBookDate === null && car.model.lastServiceBookKm === null) {
          <span class="car-detail__info-boxes-value">{{ 'globals.no' | translate }}</span>
        } @else {
          <span class="car-detail__info-boxes-value">{{ car.model.lastServiceBookDate ? (car.model.lastServiceBookDate | date: 'd.M.yyyy') : '' }} {{ 'carDetail.specification.at' | translate }} {{ car.model.lastServiceBookKm ? (car.model.lastServiceBookKm | thousands) + ' km' : '' }}</span>
        }
      </app-box-section>
    }
    <app-box-section class="car-detail__info-boxes-message" [title]="'carDetail.specification.informationCar' | translate">
      <div class="car-detail__info-boxes-message-inner">
        @if (car.webComment && car.webComment.length >= 300) {
          {{ car.webComment }}
        }
        <app-button [color]="'light'" [outlined]="true" [outline-width]="'thin'" [app-modal]="'cebia-modal'" [modal-data]="{ car: car }">
          {{ 'carDetail.specification.cebiaButton' | translate }}
          <app-icon class="car-detail__info-boxes-message-icon" [icon]="'cebia'" [fit]="true">Cebia</app-icon>
        </app-button>
      </div>
    </app-box-section>
  </div>
}
